module.exports = __webpack_public_path__ + "img/recognition1.bb247f82.jpg";